import React, { useState, useEffect } from 'react';
import {FormControl , TextField, Grid , Box, Card, CardContent , Typography,CardActions,Button } from '@mui/material/';
import axios from 'axios';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { DataGrid, GridToolbar, frFR  } from '@mui/x-data-grid';
import Cookies from 'js-cookie'

import { useSelector ,useDispatch} from 'react-redux'
import {  useNavigate  } from "react-router-dom";
import { getSessionValide ,getUserRule,setSession ,getCookieEmail,getIsAdmin} from '../../utils/userRule';

import Autorize from '../ui/autorize';

//https://react-data-table-component.netlify.app/?path=/docs/examples-filtering--filtering
function LstMembreAnnee({secteur,annee}) {

    const [listClub, setListClub] = useState("");   
    const [autorize, setAutorize] = useState("false");
    const [errorAxios, setErrorAxios] = useState("false");

    const [total, setTotal] = useState("0");
           
  
   /*
    const MyAxios = axios.create({
        headers: { 'Access-Control-Allow-Origin':  process.env.REACT_APP_API},       
        withCredentials: true,
        xsrfCookieName: 'token',
        xsrfHeaderName: 'X-XSRF-TOKEN',
    })*/
const MyAxios = axios.create({    
    headers: { Authorization: "Bearer "+ Cookies.get('token'),
            }      
})
    
    useEffect(() => { 
      //  console.log("Ajouter rapprot: " + secteur + " --" );
            
            const fetchData = async () => {
                try {

                    let RuleReport = await getUserRule("read_reports",sessionStorage.getItem('clubId'),sessionStorage.getItem('secteur'));
                    setAutorize(RuleReport);

                } catch (error) {
                    console.error('Une erreur s\'est produite lors de la récupération des données', error);
                }
            };
            fetchData(); // Appel de la fonction asynchrone
            





        if(autorize)
        {
     
           
            //, { headers: { Authorization: "Bearer "+ cookies }}
            MyAxios.get(process.env.REACT_APP_API + '/rapports/getReportMembreAjouterMois/'+ secteur + "/"+ annee) //axios.defaults.withCredentials = true
            .then((res) => {      
                setErrorAxios(false);
               // console.log(res);
                setListClub(res.data);
               
            })
            .catch((error) => {
                console.log(error)  
              ///  if(error.status)  
               if(error.response.status === 401)// pas autorisé
                setErrorAxios(true);  

            });
        }
       
    },[secteur,annee,autorize]);
   

    const navigate = useNavigate();       
    const dispatch = useDispatch();

    const onClicked = (value) => { 
        console.log("!*******:" + value);
        dispatch({ type: 'set' , payload:  value});
        sessionStorage.setItem('clubId',  value);
        sessionStorage.setItem('secteur',  secteur);
        navigate('/club',)
    };
                  
    
    
   const renderCountTotal = (ColumnName) => 
   {
        let valueAdded = 0
        let countOct = 0
        for(let i = 0 ; i < listClub.length ; i++)
        {
           // console.log(listClub[i][ColumnName]);
           if(listClub[i][ColumnName] !== null)
           {
                countOct= parseInt(listClub[i][ColumnName])
                valueAdded += countOct
           }
        }
         return valueAdded;

   }

   

        const columns = [           
            {      field: 'id',            headerName: 'id' ,        width: 0 ,     hide: true}  ,
            {      field: 'clubId',            headerName: 'Numéro de club' ,        width: 100 , }  ,
            {      field: 'ClubLegalName',            headerName: 'Nom légal du club' ,        width: 450 , }  ,
            {      field: 'Member_Roster_Number',            headerName: 'Numéro de membre' ,        width: 100 , }  ,
            {      field: 'FullName',      headerName: 'Nom complet' ,    width: 160 ,    }  ,  
            {      field: 'City',     headerName: 'Ville' ,    width: 160 ,   }  ,               
            {      field: 'Address',        headerName: 'Adresse' ,    width: 160 ,      }  ,
            {      field: 'E_Mail_Address',        headerName: 'Courriel' ,   width: 250 ,       }  ,
            {      field: 'Home_Phone_Number',        headerName: 'Téléphone maison' ,   width: 160 ,       }  ,  
         //   {      field: 'Business_Phone_Number',        headerName: 'Business_Phone_Number' ,   width: 160 ,       }  ,
          //  {      field: 'Charter_Member_Flag',        headerName: 'AddThisYear' ,   width: 160 ,       }  ,
            {      field: 'Life_Member_Status',        headerName: 'Statut membre à vie' ,   width: 160 ,       }  ,
            {      field: 'DateEffective',        headerName: 'Date d’adhésion' ,   width: 160 ,       }  ,
            {      field: 'DateDeleted',        headerName: 'Date de radiation' ,   width: 160 ,       }  ,
                          
        ];

//  {JSON.stringify(this.state.currentMember, null, 2) }     {Table}



        return (
                <div>
                    <Autorize axiosError={errorAxios} />
                     
                    <div style={{ height: 600, width: '97%' }}>
                        <DataGrid key="DataGridMember" localeText={frFR.components.MuiDataGrid.defaultProps.localeText}
                                    rows={listClub}
                                    columns={columns}
                                    pageSize={100}
                                    rowsPerPageOptions={[100]}                               
                                    components={{ Toolbar: GridToolbar }} 
                                    initialState={{
                                        filter: {
                                        filterModel: {
                                            items: [{ columnField: 'Status', operatorValue: 'equals', value: 'Actif' }],
                                        },
                                        },
                                    }}
                                    
                                />

                           
                    </div>
                   
                </div>
       
        );
   
};

export default LstMembreAnnee;